"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var mobx_react_1 = require("mobx-react");
var api_1 = __importStar(require("api"));
var config_1 = __importDefault(require("config"));
var use_stores_1 = require("hooks/use-stores");
var Modal_1 = __importDefault(require("components/modal/Modal"));
var use_notification_1 = require("hooks/use-notification");
var Notification_1 = require("../../Notification");
var utils_1 = require("../../../util/utils");
var edit_icon_svg_1 = __importDefault(require("res/img/edit-icon.svg"));
var CustomerAccountForm_1 = __importDefault(require("../CustomerAccountForm"));
var apiRoutes = config_1.default.apiRoutes;
var EditCustomerAccount = mobx_react_1.observer(function () {
    var _a = react_1.useState({}), data = _a[0], setData = _a[1];
    var _b = react_1.useState(false), success = _b[0], setSuccess = _b[1];
    var _c = use_stores_1.useStores(), apiStore = _c.apiStore, customerAccountStore = _c.customerAccountStore;
    var busyRoutes = apiStore.data.busyRoutes;
    var notification = use_notification_1.useNotification();
    var history = react_router_dom_1.useHistory();
    var priceTimeout = react_1.useRef(null);
    var successTimerRef = react_1.useRef(null);
    var params = react_router_dom_1.useParams();
    react_1.useEffect(function () {
        if (customerAccountStore.data.length <= 0 &&
            !busyRoutes.includes(apiRoutes.CUSTOMER_ACCOUNTS)) {
            api_1.default.getDeliveryCosts()
                .then(function (response) { return customerAccountStore.setData(response.data); })
                .catch(api_1.catchHandler);
        }
    }, []);
    react_1.useEffect(function () {
        for (var _i = 0, _a = customerAccountStore.data; _i < _a.length; _i++) {
            var customerAccount = _a[_i];
            if (customerAccount.id === parseInt(params.id)) {
                setData(customerAccount);
            }
        }
    }, [params.id, customerAccountStore.data.length]);
    var changeHandler = function (e) {
        var _a;
        var value = e.currentTarget.value;
        var numberEx = /^[+-]?\d+(\.\d+)?$/;
        setData(__assign(__assign({}, data), (_a = {}, _a[e.currentTarget.name] = e.currentTarget.value, _a)));
    };
    var submitHandler = function () {
        clearTimeout(successTimerRef.current);
        var customerAccount = new FormData();
        var error = null;
        if (!data.firstName || data.firstName.length <= 0)
            error = 'Please enter a first name';
        if (!data.lastName || data.lastName.length <= 0)
            error = 'Please enter a last name';
        if (!data.emailAddress || data.emailAddress.length <= 0)
            error = 'Please enter an email address';
        if (error !== null) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: error
            });
            return;
        }
        for (var k in data) {
            if (data.hasOwnProperty(k)) {
                customerAccount.append(k, data[k]);
            }
        }
        customerAccount.append('_method', 'PATCH');
        api_1.default.editCustomerAccount(data.id, customerAccount)
            .then(function (response) {
            customerAccountStore.editDataItem(response.data);
            setSuccess(true);
            successTimerRef.current = setTimeout(function () {
                setSuccess(false);
                history.replace('/customer-accounts');
            }, 1500);
        })
            .catch(api_1.catchHandler);
    };
    return (react_1.default.createElement(Modal_1.default, { title: [
            react_1.default.createElement("img", { key: "cpc_title_1", src: edit_icon_svg_1.default, alt: 'Edit Customer Account' }),
            react_1.default.createElement("span", { key: "cpc_title_2" }, "Edit Customer Account")
        ] },
        react_1.default.createElement("div", { className: 'create-product-category create-modal' },
            react_1.default.createElement(CustomerAccountForm_1.default, { data: data, onChange: changeHandler, onSubmit: submitHandler, busy: busyRoutes.includes(apiRoutes.CUSTOMER_ACCOUNTS), success: success, formType: utils_1.FormTypes.EDIT }))));
});
exports.default = EditCustomerAccount;
